try {
          document.addEventListener("DOMContentLoaded", function () {
  var audioSources = [
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/RELOOPED_-_HOOD_TRAP_PERC_BOUNCE_17_-_143_BPM.wav?v=1767966347",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/RELOOPED_-_HOOD_TRAP_PERC_BOUNCE_18_-_143_BPM.wav?v=1767966347",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/RELOOPED_-_HOOD_TRAP_PERC_BOUNCE_23_-_152_BPM.wav?v=1767966347",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/RELOOPED_-_HOOD_TRAP_PERC_BOUNCE_24_-_150_BPM.wav?v=1767966348"
  ];

  var jsonSources = [
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/bounce_17.json?v=1767966343",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/bounce_18.json?v=1767966342",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/bounce_23.json?v=1767966342",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/bounce_24.json?v=1767966343"
  ];

  const elements = document.querySelectorAll('#player-set-6 [id*="waveform-container"]');

  elements.forEach((element) => {
    const indexMatch = element.id.match(/\d+/);
    if (!indexMatch) return; // Sicherstellen, dass eine Nummer gefunden wurde
    const index = parseInt(indexMatch[0], 10);
    const adjustedIndex = index - 9; // IDs beginnen bei 10
    const container = element;
    createWaveformPlayer(index, audioSources[adjustedIndex - 1], jsonSources[adjustedIndex - 1], container);
  });

  function createWaveformPlayer(index, audioSrc, jsonSrc, container) {
    var clickCanvas = false;
    var clickProgress = 0;

    var div = document.createElement("div");
    div.setAttribute("class", "waveform");

    var canvas = document.createElement("canvas");
    canvas.width = 850;
    canvas.height = 100;
    canvas.setAttribute("class", "waveform-canvas");

    var audio = document.createElement("audio");
    audio.src = audioSrc;
    audio.preload = "auto";

    var playButton = document.createElement("div");
    playButton.setAttribute("id", "btn-contain" + index);
    playButton.setAttribute("class", "demo-btn-contain demo-btn-play");
    playButton.innerHTML =
      '<i id="pbtn' +
      index +
      '" class="demo-btn fas fa-play fa-fw fa-inverse"></i>';

    playButton.addEventListener("click", function () {
      var icon = playButton.querySelector("i");
      if (icon.classList.contains("fa-play")) {
        stopAllAudio();
        icon.classList.remove("fa-play");
        icon.classList.add("fa-pause");
        audio.play();
        audio.classList.add("playing-audio");
      } else {
        icon.classList.remove("fa-pause");
        icon.classList.add("fa-play");
        audio.pause();
        audio.classList.remove("playing-audio");
      }
    });

    var waveform = document.createElement("div");
    waveform.setAttribute("id", "waveform" + index);
    waveform.setAttribute("class", "waveform-contain");

    waveform.appendChild(canvas);

    div.appendChild(playButton);
    div.appendChild(waveform);

    div.appendChild(audio);

    container.appendChild(div);

    fetch(jsonSrc)
      .then((response) => response.json())
      .then((data) => {
        var ctx = canvas.getContext("2d");
        var samples = data.samples;

        // Hier das erste Sample nicht verändern, sondern nur beim Zeichnen überspringen
        drawWaveform(samples, ctx, canvas.width, canvas.height, 0, true); // true bedeutet, das erste Sample wird nicht gezeichnet

        canvas.addEventListener("click", function (e) {
          stopAllAudio();
          clickCanvas = true;
          var rect = canvas.getBoundingClientRect();
          var clickX = e.clientX - rect.left;
          clickProgress = clickX / rect.width;
          audio.currentTime = clickProgress * audio.duration;

          var icon = playButton.querySelector("i");
          if (icon.classList.contains("fa-play")) {
            icon.classList.remove("fa-play");
            icon.classList.add("fa-pause");
          }
          audio.play();
          audio.classList.add("playing-audio");
        });

        audio.addEventListener("loadedmetadata", () => {
          if (clickCanvas) {
            audio.currentTime = clickProgress * audio.duration;
          }
        });

        audio.addEventListener("timeupdate", function () {
          var progress = audio.currentTime / audio.duration;
          drawWaveform(samples, ctx, canvas.width, canvas.height, progress, true);
        });

        audio.addEventListener("ended", function () {
          var icon = playButton.querySelector("i");
          if (icon.classList.contains("fa-pause")) {
            icon.classList.remove("fa-pause");
            icon.classList.add("fa-play");
          }
          audio.classList.remove("playing-audio");
          drawWaveform(samples, ctx, canvas.width, canvas.height, 0, true);
        });
      })
      .catch((error) => console.error("Error fetching JSON data:", error));
  }

  /**
   * Zeichnet die Wellenform auf das Canvas.
   * @param {Array<number>} samples - Die Audiodaten.
   * @param {CanvasRenderingContext2D} ctx - Der Canvas-Zeichenkontext.
   * @param {number} width - Die Breite des Canvas.
   * @param {number} height - Die Höhe des Canvas.
   * @param {number} progress - Der Fortschritt der Wiedergabe (zwischen 0 und 1).
   * @param {boolean} skipFirstSample - Ob das erste Sample übersprungen werden soll.
   */
  function drawWaveform(samples, ctx, width, height, progress, skipFirstSample = false) {
    var maxAbsoluteValue = Math.max(...samples.map(Math.abs));
    var halfHeight = height / 2;
    var step = halfHeight / maxAbsoluteValue;
    var endIndex = Math.floor(samples.length * progress);

    ctx.clearRect(0, 0, width, height);

    // Start bei 1, wenn das erste Sample übersprungen werden soll
    var start = skipFirstSample ? 1 : 0;

    for (var i = start; i < samples.length; i++) {
      var normalizedSample = Math.abs(samples[i]) * step;
      var x = (i / samples.length) * width;
      var y1 = halfHeight - normalizedSample;
      var y2 = halfHeight + normalizedSample;

      ctx.strokeStyle = i <= endIndex ? "#eee" : "#555";
      ctx.lineWidth = 4;
      ctx.beginPath();
      ctx.moveTo(x, y1);
      ctx.lineTo(x, y2);
      ctx.stroke();
    }
  }

  /**
   * Stoppt alle aktuell spielenden Audio-Elemente und setzt deren Zustand zurück.
   */
  function stopAllAudio() {
    var allAudio = document.querySelectorAll("audio.playing-audio");
    allAudio.forEach((audio) => {
      audio.pause();
      audio.currentTime = 0;
      audio.classList.remove("playing-audio");

      // Finden des zugehörigen Play-Buttons anhand des Containers
      var container = audio.parentElement;
      var playButton = container.querySelector(".demo-btn-contain");
      if (playButton) {
        var icon = playButton.querySelector("i");
        if (icon && icon.classList.contains("fa-pause")) {
          icon.classList.remove("fa-pause");
          icon.classList.add("fa-play");
        }
      }
    });
  }
});

        } catch(err){}
;
try {
          document.addEventListener("DOMContentLoaded", function () {
  var audioSources = [
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/RELOOPED_-_HOOD_TRAP_PERC_BOUNCE_17_-_143_BPM.wav?v=1767966347",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/RELOOPED_-_HOOD_TRAP_PERC_BOUNCE_18_-_143_BPM.wav?v=1767966347",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/RELOOPED_-_HOOD_TRAP_PERC_BOUNCE_23_-_152_BPM.wav?v=1767966347",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/RELOOPED_-_HOOD_TRAP_PERC_BOUNCE_24_-_150_BPM.wav?v=1767966348"
  ];

  var jsonSources = [
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/bounce_17.json?v=1767966343",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/bounce_18.json?v=1767966342",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/bounce_23.json?v=1767966342",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/bounce_24.json?v=1767966343"
  ];

  const elements = document.querySelectorAll('#player-set-8 [id*="waveform-container"]');

  elements.forEach((element) => {
    const indexMatch = element.id.match(/\d+/);
    if (!indexMatch) return; // Sicherstellen, dass eine Nummer gefunden wurde
    const index = parseInt(indexMatch[0], 10);
    const adjustedIndex = index - 9; // IDs beginnen bei 10
    const container = element;
    createWaveformPlayer(index, audioSources[adjustedIndex - 1], jsonSources[adjustedIndex - 1], container);
  });

  function createWaveformPlayer(index, audioSrc, jsonSrc, container) {
    var clickCanvas = false;
    var clickProgress = 0;

    var div = document.createElement("div");
    div.setAttribute("class", "waveform");

    var canvas = document.createElement("canvas");
    canvas.width = 850;
    canvas.height = 100;
    canvas.setAttribute("class", "waveform-canvas");

    var audio = document.createElement("audio");
    audio.src = audioSrc;
    audio.preload = "auto";

    var playButton = document.createElement("div");
    playButton.setAttribute("id", "btn-contain" + index);
    playButton.setAttribute("class", "demo-btn-contain demo-btn-play");
    playButton.innerHTML =
      '<i id="pbtn' +
      index +
      '" class="demo-btn fas fa-play fa-fw fa-inverse"></i>';

    playButton.addEventListener("click", function () {
      var icon = playButton.querySelector("i");
      if (icon.classList.contains("fa-play")) {
        stopAllAudio();
        icon.classList.remove("fa-play");
        icon.classList.add("fa-pause");
        audio.play();
        audio.classList.add("playing-audio");
      } else {
        icon.classList.remove("fa-pause");
        icon.classList.add("fa-play");
        audio.pause();
        audio.classList.remove("playing-audio");
      }
    });

    var waveform = document.createElement("div");
    waveform.setAttribute("id", "waveform" + index);
    waveform.setAttribute("class", "waveform-contain");

    waveform.appendChild(canvas);

    div.appendChild(playButton);
    div.appendChild(waveform);

    div.appendChild(audio);

    container.appendChild(div);

    fetch(jsonSrc)
      .then((response) => response.json())
      .then((data) => {
        var ctx = canvas.getContext("2d");
        var samples = data.samples;

        // Hier das erste Sample nicht verändern, sondern nur beim Zeichnen überspringen
        drawWaveform(samples, ctx, canvas.width, canvas.height, 0, true); // true bedeutet, das erste Sample wird nicht gezeichnet

        canvas.addEventListener("click", function (e) {
          stopAllAudio();
          clickCanvas = true;
          var rect = canvas.getBoundingClientRect();
          var clickX = e.clientX - rect.left;
          clickProgress = clickX / rect.width;
          audio.currentTime = clickProgress * audio.duration;

          var icon = playButton.querySelector("i");
          if (icon.classList.contains("fa-play")) {
            icon.classList.remove("fa-play");
            icon.classList.add("fa-pause");
          }
          audio.play();
          audio.classList.add("playing-audio");
        });

        audio.addEventListener("loadedmetadata", () => {
          if (clickCanvas) {
            audio.currentTime = clickProgress * audio.duration;
          }
        });

        audio.addEventListener("timeupdate", function () {
          var progress = audio.currentTime / audio.duration;
          drawWaveform(samples, ctx, canvas.width, canvas.height, progress, true);
        });

        audio.addEventListener("ended", function () {
          var icon = playButton.querySelector("i");
          if (icon.classList.contains("fa-pause")) {
            icon.classList.remove("fa-pause");
            icon.classList.add("fa-play");
          }
          audio.classList.remove("playing-audio");
          drawWaveform(samples, ctx, canvas.width, canvas.height, 0, true);
        });
      })
      .catch((error) => console.error("Error fetching JSON data:", error));
  }

  /**
   * Zeichnet die Wellenform auf das Canvas.
   * @param {Array<number>} samples - Die Audiodaten.
   * @param {CanvasRenderingContext2D} ctx - Der Canvas-Zeichenkontext.
   * @param {number} width - Die Breite des Canvas.
   * @param {number} height - Die Höhe des Canvas.
   * @param {number} progress - Der Fortschritt der Wiedergabe (zwischen 0 und 1).
   * @param {boolean} skipFirstSample - Ob das erste Sample übersprungen werden soll.
   */
  function drawWaveform(samples, ctx, width, height, progress, skipFirstSample = false) {
    var maxAbsoluteValue = Math.max(...samples.map(Math.abs));
    var halfHeight = height / 2;
    var step = halfHeight / maxAbsoluteValue;
    var endIndex = Math.floor(samples.length * progress);

    ctx.clearRect(0, 0, width, height);

    // Start bei 1, wenn das erste Sample übersprungen werden soll
    var start = skipFirstSample ? 1 : 0;

    for (var i = start; i < samples.length; i++) {
      var normalizedSample = Math.abs(samples[i]) * step;
      var x = (i / samples.length) * width;
      var y1 = halfHeight - normalizedSample;
      var y2 = halfHeight + normalizedSample;

      ctx.strokeStyle = i <= endIndex ? "#eee" : "#555";
      ctx.lineWidth = 4;
      ctx.beginPath();
      ctx.moveTo(x, y1);
      ctx.lineTo(x, y2);
      ctx.stroke();
    }
  }

  /**
   * Stoppt alle aktuell spielenden Audio-Elemente und setzt deren Zustand zurück.
   */
  function stopAllAudio() {
    var allAudio = document.querySelectorAll("audio.playing-audio");
    allAudio.forEach((audio) => {
      audio.pause();
      audio.currentTime = 0;
      audio.classList.remove("playing-audio");

      // Finden des zugehörigen Play-Buttons anhand des Containers
      var container = audio.parentElement;
      var playButton = container.querySelector(".demo-btn-contain");
      if (playButton) {
        var icon = playButton.querySelector("i");
        if (icon && icon.classList.contains("fa-pause")) {
          icon.classList.remove("fa-pause");
          icon.classList.add("fa-play");
        }
      }
    });
  }
});

        } catch(err){}
;
try {
          document.addEventListener("DOMContentLoaded", function () {
  var audioSources = [
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/drumloop_5_145.mp3?v=1767966927",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/drumloop_6_143.mp3?v=1767966927",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/drumloop_10_143.mp3?v=1767966927",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/drumloop_11_152.mp3?v=1767966927"
  ];

  var jsonSources = [
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/drumloop_5.json?v=1767966924",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/drumloop_6.json?v=1767966924",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/drumloop_10.json?v=1767966924",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/drumloop_11.json?v=1767966924"
  ];

  const elements = document.querySelectorAll('#player-set-88 [id*="waveform-container"]');

  elements.forEach((element) => {
    const indexMatch = element.id.match(/\d+/);
    if (!indexMatch) return; // Sicherstellen, dass eine Nummer gefunden wurde
    const index = parseInt(indexMatch[0], 10);
    const adjustedIndex = index - 9; // IDs beginnen bei 10
    const container = element;
    createWaveformPlayer(index, audioSources[adjustedIndex - 1], jsonSources[adjustedIndex - 1], container);
  });

  function createWaveformPlayer(index, audioSrc, jsonSrc, container) {
    var clickCanvas = false;
    var clickProgress = 0;

    var div = document.createElement("div");
    div.setAttribute("class", "waveform");

    var canvas = document.createElement("canvas");
    canvas.width = 850;
    canvas.height = 100;
    canvas.setAttribute("class", "waveform-canvas");

    var audio = document.createElement("audio");
    audio.src = audioSrc;
    audio.preload = "auto";

    var playButton = document.createElement("div");
    playButton.setAttribute("id", "btn-contain" + index);
    playButton.setAttribute("class", "demo-btn-contain demo-btn-play");
    playButton.innerHTML =
      '<i id="pbtn' +
      index +
      '" class="demo-btn fas fa-play fa-fw fa-inverse"></i>';

    playButton.addEventListener("click", function () {
      var icon = playButton.querySelector("i");
      if (icon.classList.contains("fa-play")) {
        stopAllAudio();
        icon.classList.remove("fa-play");
        icon.classList.add("fa-pause");
        audio.play();
        audio.classList.add("playing-audio");
      } else {
        icon.classList.remove("fa-pause");
        icon.classList.add("fa-play");
        audio.pause();
        audio.classList.remove("playing-audio");
      }
    });

    var waveform = document.createElement("div");
    waveform.setAttribute("id", "waveform" + index);
    waveform.setAttribute("class", "waveform-contain");

    waveform.appendChild(canvas);

    div.appendChild(playButton);
    div.appendChild(waveform);

    div.appendChild(audio);

    container.appendChild(div);

    fetch(jsonSrc)
      .then((response) => response.json())
      .then((data) => {
        var ctx = canvas.getContext("2d");
        var samples = data.samples;

        // Hier das erste Sample nicht verändern, sondern nur beim Zeichnen überspringen
        drawWaveform(samples, ctx, canvas.width, canvas.height, 0, true); // true bedeutet, das erste Sample wird nicht gezeichnet

        canvas.addEventListener("click", function (e) {
          stopAllAudio();
          clickCanvas = true;
          var rect = canvas.getBoundingClientRect();
          var clickX = e.clientX - rect.left;
          clickProgress = clickX / rect.width;
          audio.currentTime = clickProgress * audio.duration;

          var icon = playButton.querySelector("i");
          if (icon.classList.contains("fa-play")) {
            icon.classList.remove("fa-play");
            icon.classList.add("fa-pause");
          }
          audio.play();
          audio.classList.add("playing-audio");
        });

        audio.addEventListener("loadedmetadata", () => {
          if (clickCanvas) {
            audio.currentTime = clickProgress * audio.duration;
          }
        });

        audio.addEventListener("timeupdate", function () {
          var progress = audio.currentTime / audio.duration;
          drawWaveform(samples, ctx, canvas.width, canvas.height, progress, true);
        });

        audio.addEventListener("ended", function () {
          var icon = playButton.querySelector("i");
          if (icon.classList.contains("fa-pause")) {
            icon.classList.remove("fa-pause");
            icon.classList.add("fa-play");
          }
          audio.classList.remove("playing-audio");
          drawWaveform(samples, ctx, canvas.width, canvas.height, 0, true);
        });
      })
      .catch((error) => console.error("Error fetching JSON data:", error));
  }

  /**
   * Zeichnet die Wellenform auf das Canvas.
   * @param {Array<number>} samples - Die Audiodaten.
   * @param {CanvasRenderingContext2D} ctx - Der Canvas-Zeichenkontext.
   * @param {number} width - Die Breite des Canvas.
   * @param {number} height - Die Höhe des Canvas.
   * @param {number} progress - Der Fortschritt der Wiedergabe (zwischen 0 und 1).
   * @param {boolean} skipFirstSample - Ob das erste Sample übersprungen werden soll.
   */
  function drawWaveform(samples, ctx, width, height, progress, skipFirstSample = false) {
    var maxAbsoluteValue = Math.max(...samples.map(Math.abs));
    var halfHeight = height / 2;
    var step = halfHeight / maxAbsoluteValue;
    var endIndex = Math.floor(samples.length * progress);

    ctx.clearRect(0, 0, width, height);

    // Start bei 1, wenn das erste Sample übersprungen werden soll
    var start = skipFirstSample ? 1 : 0;

    for (var i = start; i < samples.length; i++) {
      var normalizedSample = Math.abs(samples[i]) * step;
      var x = (i / samples.length) * width;
      var y1 = halfHeight - normalizedSample;
      var y2 = halfHeight + normalizedSample;

      ctx.strokeStyle = i <= endIndex ? "#eee" : "#555";
      ctx.lineWidth = 4;
      ctx.beginPath();
      ctx.moveTo(x, y1);
      ctx.lineTo(x, y2);
      ctx.stroke();
    }
  }

  /**
   * Stoppt alle aktuell spielenden Audio-Elemente und setzt deren Zustand zurück.
   */
  function stopAllAudio() {
    var allAudio = document.querySelectorAll("audio.playing-audio");
    allAudio.forEach((audio) => {
      audio.pause();
      audio.currentTime = 0;
      audio.classList.remove("playing-audio");

      // Finden des zugehörigen Play-Buttons anhand des Containers
      var container = audio.parentElement;
      var playButton = container.querySelector(".demo-btn-contain");
      if (playButton) {
        var icon = playButton.querySelector("i");
        if (icon && icon.classList.contains("fa-pause")) {
          icon.classList.remove("fa-pause");
          icon.classList.add("fa-play");
        }
      }
    });
  }
});

        } catch(err){}
;
try {
          document.addEventListener("DOMContentLoaded", function () {
  var audioSources = [
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/drumloop_5_145.mp3?v=1767966927",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/drumloop_6_143.mp3?v=1767966927",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/drumloop_10_143.mp3?v=1767966927",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/drumloop_11_152.mp3?v=1767966927"
  ];

  var jsonSources = [
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/drumloop_5.json?v=1767966924",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/drumloop_6.json?v=1767966924",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/drumloop_10.json?v=1767966924",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/drumloop_11.json?v=1767966924"
  ];

  const elements = document.querySelectorAll('#player-set-512 [id*="waveform-container"]');

  elements.forEach((element) => {
    const indexMatch = element.id.match(/\d+/);
    if (!indexMatch) return; // Sicherstellen, dass eine Nummer gefunden wurde
    const index = parseInt(indexMatch[0], 10);
    const adjustedIndex = index - 9; // IDs beginnen bei 10
    const container = element;
    createWaveformPlayer(index, audioSources[adjustedIndex - 1], jsonSources[adjustedIndex - 1], container);
  });

  function createWaveformPlayer(index, audioSrc, jsonSrc, container) {
    var clickCanvas = false;
    var clickProgress = 0;

    var div = document.createElement("div");
    div.setAttribute("class", "waveform");

    var canvas = document.createElement("canvas");
    canvas.width = 850;
    canvas.height = 100;
    canvas.setAttribute("class", "waveform-canvas");

    var audio = document.createElement("audio");
    audio.src = audioSrc;
    audio.preload = "auto";

    var playButton = document.createElement("div");
    playButton.setAttribute("id", "btn-contain" + index);
    playButton.setAttribute("class", "demo-btn-contain demo-btn-play");
    playButton.innerHTML =
      '<i id="pbtn' +
      index +
      '" class="demo-btn fas fa-play fa-fw fa-inverse"></i>';

    playButton.addEventListener("click", function () {
      var icon = playButton.querySelector("i");
      if (icon.classList.contains("fa-play")) {
        stopAllAudio();
        icon.classList.remove("fa-play");
        icon.classList.add("fa-pause");
        audio.play();
        audio.classList.add("playing-audio");
      } else {
        icon.classList.remove("fa-pause");
        icon.classList.add("fa-play");
        audio.pause();
        audio.classList.remove("playing-audio");
      }
    });

    var waveform = document.createElement("div");
    waveform.setAttribute("id", "waveform" + index);
    waveform.setAttribute("class", "waveform-contain");

    waveform.appendChild(canvas);

    div.appendChild(playButton);
    div.appendChild(waveform);

    div.appendChild(audio);

    container.appendChild(div);

    fetch(jsonSrc)
      .then((response) => response.json())
      .then((data) => {
        var ctx = canvas.getContext("2d");
        var samples = data.samples;

        // Hier das erste Sample nicht verändern, sondern nur beim Zeichnen überspringen
        drawWaveform(samples, ctx, canvas.width, canvas.height, 0, true); // true bedeutet, das erste Sample wird nicht gezeichnet

        canvas.addEventListener("click", function (e) {
          stopAllAudio();
          clickCanvas = true;
          var rect = canvas.getBoundingClientRect();
          var clickX = e.clientX - rect.left;
          clickProgress = clickX / rect.width;
          audio.currentTime = clickProgress * audio.duration;

          var icon = playButton.querySelector("i");
          if (icon.classList.contains("fa-play")) {
            icon.classList.remove("fa-play");
            icon.classList.add("fa-pause");
          }
          audio.play();
          audio.classList.add("playing-audio");
        });

        audio.addEventListener("loadedmetadata", () => {
          if (clickCanvas) {
            audio.currentTime = clickProgress * audio.duration;
          }
        });

        audio.addEventListener("timeupdate", function () {
          var progress = audio.currentTime / audio.duration;
          drawWaveform(samples, ctx, canvas.width, canvas.height, progress, true);
        });

        audio.addEventListener("ended", function () {
          var icon = playButton.querySelector("i");
          if (icon.classList.contains("fa-pause")) {
            icon.classList.remove("fa-pause");
            icon.classList.add("fa-play");
          }
          audio.classList.remove("playing-audio");
          drawWaveform(samples, ctx, canvas.width, canvas.height, 0, true);
        });
      })
      .catch((error) => console.error("Error fetching JSON data:", error));
  }

  /**
   * Zeichnet die Wellenform auf das Canvas.
   * @param {Array<number>} samples - Die Audiodaten.
   * @param {CanvasRenderingContext2D} ctx - Der Canvas-Zeichenkontext.
   * @param {number} width - Die Breite des Canvas.
   * @param {number} height - Die Höhe des Canvas.
   * @param {number} progress - Der Fortschritt der Wiedergabe (zwischen 0 und 1).
   * @param {boolean} skipFirstSample - Ob das erste Sample übersprungen werden soll.
   */
  function drawWaveform(samples, ctx, width, height, progress, skipFirstSample = false) {
    var maxAbsoluteValue = Math.max(...samples.map(Math.abs));
    var halfHeight = height / 2;
    var step = halfHeight / maxAbsoluteValue;
    var endIndex = Math.floor(samples.length * progress);

    ctx.clearRect(0, 0, width, height);

    // Start bei 1, wenn das erste Sample übersprungen werden soll
    var start = skipFirstSample ? 1 : 0;

    for (var i = start; i < samples.length; i++) {
      var normalizedSample = Math.abs(samples[i]) * step;
      var x = (i / samples.length) * width;
      var y1 = halfHeight - normalizedSample;
      var y2 = halfHeight + normalizedSample;

      ctx.strokeStyle = i <= endIndex ? "#eee" : "#555";
      ctx.lineWidth = 4;
      ctx.beginPath();
      ctx.moveTo(x, y1);
      ctx.lineTo(x, y2);
      ctx.stroke();
    }
  }

  /**
   * Stoppt alle aktuell spielenden Audio-Elemente und setzt deren Zustand zurück.
   */
  function stopAllAudio() {
    var allAudio = document.querySelectorAll("audio.playing-audio");
    allAudio.forEach((audio) => {
      audio.pause();
      audio.currentTime = 0;
      audio.classList.remove("playing-audio");

      // Finden des zugehörigen Play-Buttons anhand des Containers
      var container = audio.parentElement;
      var playButton = container.querySelector(".demo-btn-contain");
      if (playButton) {
        var icon = playButton.querySelector("i");
        if (icon && icon.classList.contains("fa-pause")) {
          icon.classList.remove("fa-pause");
          icon.classList.add("fa-play");
        }
      }
    });
  }
});

        } catch(err){}
;
try {
          document.addEventListener("DOMContentLoaded", function () {
  var audioSources = [
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/kick_midi_3.mp3?v=1767967049",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/snare_midi_10.mp3?v=1767967048",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/stomp_midi_4.mp3?v=1767967048",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/snare_midi_11.mp3?v=1767967048"
  ];

  var jsonSources = [
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/kick_midi_3.json?v=1767967045",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/snare_midi_10.json?v=1767967045",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/stomp_midi_4.json?v=1767967045",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/snare_midi_11.json?v=1767967045"
  ];

  const elements = document.querySelectorAll('#player-set-116 [id*="waveform-container"]');

  elements.forEach((element) => {
    const indexMatch = element.id.match(/\d+/);
    if (!indexMatch) return; // Sicherstellen, dass eine Nummer gefunden wurde
    const index = parseInt(indexMatch[0], 10);
    const adjustedIndex = index - 9; // IDs beginnen bei 10
    const container = element;
    createWaveformPlayer(index, audioSources[adjustedIndex - 1], jsonSources[adjustedIndex - 1], container);
  });

  function createWaveformPlayer(index, audioSrc, jsonSrc, container) {
    var clickCanvas = false;
    var clickProgress = 0;

    var div = document.createElement("div");
    div.setAttribute("class", "waveform");

    var canvas = document.createElement("canvas");
    canvas.width = 850;
    canvas.height = 100;
    canvas.setAttribute("class", "waveform-canvas");

    var audio = document.createElement("audio");
    audio.src = audioSrc;
    audio.preload = "auto";

    var playButton = document.createElement("div");
    playButton.setAttribute("id", "btn-contain" + index);
    playButton.setAttribute("class", "demo-btn-contain demo-btn-play");
    playButton.innerHTML =
      '<i id="pbtn' +
      index +
      '" class="demo-btn fas fa-play fa-fw fa-inverse"></i>';

    playButton.addEventListener("click", function () {
      var icon = playButton.querySelector("i");
      if (icon.classList.contains("fa-play")) {
        stopAllAudio();
        icon.classList.remove("fa-play");
        icon.classList.add("fa-pause");
        audio.play();
        audio.classList.add("playing-audio");
      } else {
        icon.classList.remove("fa-pause");
        icon.classList.add("fa-play");
        audio.pause();
        audio.classList.remove("playing-audio");
      }
    });

    var waveform = document.createElement("div");
    waveform.setAttribute("id", "waveform" + index);
    waveform.setAttribute("class", "waveform-contain");

    waveform.appendChild(canvas);

    div.appendChild(playButton);
    div.appendChild(waveform);

    div.appendChild(audio);

    container.appendChild(div);

    fetch(jsonSrc)
      .then((response) => response.json())
      .then((data) => {
        var ctx = canvas.getContext("2d");
        var samples = data.samples;

        // Hier das erste Sample nicht verändern, sondern nur beim Zeichnen überspringen
        drawWaveform(samples, ctx, canvas.width, canvas.height, 0, true); // true bedeutet, das erste Sample wird nicht gezeichnet

        canvas.addEventListener("click", function (e) {
          stopAllAudio();
          clickCanvas = true;
          var rect = canvas.getBoundingClientRect();
          var clickX = e.clientX - rect.left;
          clickProgress = clickX / rect.width;
          audio.currentTime = clickProgress * audio.duration;

          var icon = playButton.querySelector("i");
          if (icon.classList.contains("fa-play")) {
            icon.classList.remove("fa-play");
            icon.classList.add("fa-pause");
          }
          audio.play();
          audio.classList.add("playing-audio");
        });

        audio.addEventListener("loadedmetadata", () => {
          if (clickCanvas) {
            audio.currentTime = clickProgress * audio.duration;
          }
        });

        audio.addEventListener("timeupdate", function () {
          var progress = audio.currentTime / audio.duration;
          drawWaveform(samples, ctx, canvas.width, canvas.height, progress, true);
        });

        audio.addEventListener("ended", function () {
          var icon = playButton.querySelector("i");
          if (icon.classList.contains("fa-pause")) {
            icon.classList.remove("fa-pause");
            icon.classList.add("fa-play");
          }
          audio.classList.remove("playing-audio");
          drawWaveform(samples, ctx, canvas.width, canvas.height, 0, true);
        });
      })
      .catch((error) => console.error("Error fetching JSON data:", error));
  }

  /**
   * Zeichnet die Wellenform auf das Canvas.
   * @param {Array<number>} samples - Die Audiodaten.
   * @param {CanvasRenderingContext2D} ctx - Der Canvas-Zeichenkontext.
   * @param {number} width - Die Breite des Canvas.
   * @param {number} height - Die Höhe des Canvas.
   * @param {number} progress - Der Fortschritt der Wiedergabe (zwischen 0 und 1).
   * @param {boolean} skipFirstSample - Ob das erste Sample übersprungen werden soll.
   */
  function drawWaveform(samples, ctx, width, height, progress, skipFirstSample = false) {
    var maxAbsoluteValue = Math.max(...samples.map(Math.abs));
    var halfHeight = height / 2;
    var step = halfHeight / maxAbsoluteValue;
    var endIndex = Math.floor(samples.length * progress);

    ctx.clearRect(0, 0, width, height);

    // Start bei 1, wenn das erste Sample übersprungen werden soll
    var start = skipFirstSample ? 1 : 0;

    for (var i = start; i < samples.length; i++) {
      var normalizedSample = Math.abs(samples[i]) * step;
      var x = (i / samples.length) * width;
      var y1 = halfHeight - normalizedSample;
      var y2 = halfHeight + normalizedSample;

      ctx.strokeStyle = i <= endIndex ? "#eee" : "#555";
      ctx.lineWidth = 4;
      ctx.beginPath();
      ctx.moveTo(x, y1);
      ctx.lineTo(x, y2);
      ctx.stroke();
    }
  }

  /**
   * Stoppt alle aktuell spielenden Audio-Elemente und setzt deren Zustand zurück.
   */
  function stopAllAudio() {
    var allAudio = document.querySelectorAll("audio.playing-audio");
    allAudio.forEach((audio) => {
      audio.pause();
      audio.currentTime = 0;
      audio.classList.remove("playing-audio");

      // Finden des zugehörigen Play-Buttons anhand des Containers
      var container = audio.parentElement;
      var playButton = container.querySelector(".demo-btn-contain");
      if (playButton) {
        var icon = playButton.querySelector("i");
        if (icon && icon.classList.contains("fa-pause")) {
          icon.classList.remove("fa-pause");
          icon.classList.add("fa-play");
        }
      }
    });
  }
});

        } catch(err){}
;
try {
          document.addEventListener("DOMContentLoaded", function () {
  var audioSources = [
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/drum_loop_8_155bpm.mp3?v=1770728000",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/drum_loop_12_147bpm.mp3?v=1770728001",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/drum_loop_13_151bpm.mp3?v=1770728001",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/drum_loop_19_151bpm.mp3?v=1770728000"
  ];

  var jsonSources = [
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/drum_loop_8_155bpm.json?v=1770727999",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/drum_loop_12_147bpm.json?v=1770727999",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/drum_loop_13_151bpm.json?v=1770727999",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/drum_loop_19_151bpm.json?v=1770727999"
  ];

  const elements = document.querySelectorAll('#player-set-6666 [id*="waveform-container"]');

  elements.forEach((element) => {
    const indexMatch = element.id.match(/\d+/);
    if (!indexMatch) return; // Sicherstellen, dass eine Nummer gefunden wurde
    const index = parseInt(indexMatch[0], 10);
    const adjustedIndex = index - 9; // IDs beginnen bei 10
    const container = element;
    createWaveformPlayer(index, audioSources[adjustedIndex - 1], jsonSources[adjustedIndex - 1], container);
  });

  function createWaveformPlayer(index, audioSrc, jsonSrc, container) {
    var clickCanvas = false;
    var clickProgress = 0;

    var div = document.createElement("div");
    div.setAttribute("class", "waveform");

    var canvas = document.createElement("canvas");
    canvas.width = 850;
    canvas.height = 100;
    canvas.setAttribute("class", "waveform-canvas");

    var audio = document.createElement("audio");
    audio.src = audioSrc;
    audio.preload = "auto";

    var playButton = document.createElement("div");
    playButton.setAttribute("id", "btn-contain" + index);
    playButton.setAttribute("class", "demo-btn-contain demo-btn-play");
    playButton.innerHTML =
      '<i id="pbtn' +
      index +
      '" class="demo-btn fas fa-play fa-fw fa-inverse"></i>';

    playButton.addEventListener("click", function () {
      var icon = playButton.querySelector("i");
      if (icon.classList.contains("fa-play")) {
        stopAllAudio();
        icon.classList.remove("fa-play");
        icon.classList.add("fa-pause");
        audio.play();
        audio.classList.add("playing-audio");
      } else {
        icon.classList.remove("fa-pause");
        icon.classList.add("fa-play");
        audio.pause();
        audio.classList.remove("playing-audio");
      }
    });

    var waveform = document.createElement("div");
    waveform.setAttribute("id", "waveform" + index);
    waveform.setAttribute("class", "waveform-contain");

    waveform.appendChild(canvas);

    div.appendChild(playButton);
    div.appendChild(waveform);

    div.appendChild(audio);

    container.appendChild(div);

    fetch(jsonSrc)
      .then((response) => response.json())
      .then((data) => {
        var ctx = canvas.getContext("2d");
        var samples = data.samples;

        // Hier das erste Sample nicht verändern, sondern nur beim Zeichnen überspringen
        drawWaveform(samples, ctx, canvas.width, canvas.height, 0, true); // true bedeutet, das erste Sample wird nicht gezeichnet

        canvas.addEventListener("click", function (e) {
          stopAllAudio();
          clickCanvas = true;
          var rect = canvas.getBoundingClientRect();
          var clickX = e.clientX - rect.left;
          clickProgress = clickX / rect.width;
          audio.currentTime = clickProgress * audio.duration;

          var icon = playButton.querySelector("i");
          if (icon.classList.contains("fa-play")) {
            icon.classList.remove("fa-play");
            icon.classList.add("fa-pause");
          }
          audio.play();
          audio.classList.add("playing-audio");
        });

        audio.addEventListener("loadedmetadata", () => {
          if (clickCanvas) {
            audio.currentTime = clickProgress * audio.duration;
          }
        });

        audio.addEventListener("timeupdate", function () {
          var progress = audio.currentTime / audio.duration;
          drawWaveform(samples, ctx, canvas.width, canvas.height, progress, true);
        });

        audio.addEventListener("ended", function () {
          var icon = playButton.querySelector("i");
          if (icon.classList.contains("fa-pause")) {
            icon.classList.remove("fa-pause");
            icon.classList.add("fa-play");
          }
          audio.classList.remove("playing-audio");
          drawWaveform(samples, ctx, canvas.width, canvas.height, 0, true);
        });
      })
      .catch((error) => console.error("Error fetching JSON data:", error));
  }

  /**
   * Zeichnet die Wellenform auf das Canvas.
   * @param {Array<number>} samples - Die Audiodaten.
   * @param {CanvasRenderingContext2D} ctx - Der Canvas-Zeichenkontext.
   * @param {number} width - Die Breite des Canvas.
   * @param {number} height - Die Höhe des Canvas.
   * @param {number} progress - Der Fortschritt der Wiedergabe (zwischen 0 und 1).
   * @param {boolean} skipFirstSample - Ob das erste Sample übersprungen werden soll.
   */
  function drawWaveform(samples, ctx, width, height, progress, skipFirstSample = false) {
    var maxAbsoluteValue = Math.max(...samples.map(Math.abs));
    var halfHeight = height / 2;
    var step = halfHeight / maxAbsoluteValue;
    var endIndex = Math.floor(samples.length * progress);

    ctx.clearRect(0, 0, width, height);

    // Start bei 1, wenn das erste Sample übersprungen werden soll
    var start = skipFirstSample ? 1 : 0;

    for (var i = start; i < samples.length; i++) {
      var normalizedSample = Math.abs(samples[i]) * step;
      var x = (i / samples.length) * width;
      var y1 = halfHeight - normalizedSample;
      var y2 = halfHeight + normalizedSample;

      ctx.strokeStyle = i <= endIndex ? "#eee" : "#555";
      ctx.lineWidth = 4;
      ctx.beginPath();
      ctx.moveTo(x, y1);
      ctx.lineTo(x, y2);
      ctx.stroke();
    }
  }

  /**
   * Stoppt alle aktuell spielenden Audio-Elemente und setzt deren Zustand zurück.
   */
  function stopAllAudio() {
    var allAudio = document.querySelectorAll("audio.playing-audio");
    allAudio.forEach((audio) => {
      audio.pause();
      audio.currentTime = 0;
      audio.classList.remove("playing-audio");

      // Finden des zugehörigen Play-Buttons anhand des Containers
      var container = audio.parentElement;
      var playButton = container.querySelector(".demo-btn-contain");
      if (playButton) {
        var icon = playButton.querySelector("i");
        if (icon && icon.classList.contains("fa-pause")) {
          icon.classList.remove("fa-pause");
          icon.classList.add("fa-play");
        }
      }
    });
  }
});

        } catch(err){}
;
try {
          document.addEventListener("DOMContentLoaded", function () {
  var audioSources = [
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/kick_midi_3.mp3?v=1767967049",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/snare_midi_10.mp3?v=1767967048",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/stomp_midi_4.mp3?v=1767967048",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/snare_midi_11.mp3?v=1767967048"
  ];

  var jsonSources = [
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/kick_midi_3.json?v=1767967045",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/snare_midi_10.json?v=1767967045",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/stomp_midi_4.json?v=1767967045",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/snare_midi_11.json?v=1767967045"
  ];

  const elements = document.querySelectorAll('#player-set-888 [id*="waveform-container"]');

  elements.forEach((element) => {
    const indexMatch = element.id.match(/\d+/);
    if (!indexMatch) return; // Sicherstellen, dass eine Nummer gefunden wurde
    const index = parseInt(indexMatch[0], 10);
    const adjustedIndex = index - 9; // IDs beginnen bei 10
    const container = element;
    createWaveformPlayer(index, audioSources[adjustedIndex - 1], jsonSources[adjustedIndex - 1], container);
  });

  function createWaveformPlayer(index, audioSrc, jsonSrc, container) {
    var clickCanvas = false;
    var clickProgress = 0;

    var div = document.createElement("div");
    div.setAttribute("class", "waveform");

    var canvas = document.createElement("canvas");
    canvas.width = 850;
    canvas.height = 100;
    canvas.setAttribute("class", "waveform-canvas");

    var audio = document.createElement("audio");
    audio.src = audioSrc;
    audio.preload = "auto";

    var playButton = document.createElement("div");
    playButton.setAttribute("id", "btn-contain" + index);
    playButton.setAttribute("class", "demo-btn-contain demo-btn-play");
    playButton.innerHTML =
      '<i id="pbtn' +
      index +
      '" class="demo-btn fas fa-play fa-fw fa-inverse"></i>';

    playButton.addEventListener("click", function () {
      var icon = playButton.querySelector("i");
      if (icon.classList.contains("fa-play")) {
        stopAllAudio();
        icon.classList.remove("fa-play");
        icon.classList.add("fa-pause");
        audio.play();
        audio.classList.add("playing-audio");
      } else {
        icon.classList.remove("fa-pause");
        icon.classList.add("fa-play");
        audio.pause();
        audio.classList.remove("playing-audio");
      }
    });

    var waveform = document.createElement("div");
    waveform.setAttribute("id", "waveform" + index);
    waveform.setAttribute("class", "waveform-contain");

    waveform.appendChild(canvas);

    div.appendChild(playButton);
    div.appendChild(waveform);

    div.appendChild(audio);

    container.appendChild(div);

    fetch(jsonSrc)
      .then((response) => response.json())
      .then((data) => {
        var ctx = canvas.getContext("2d");
        var samples = data.samples;

        // Hier das erste Sample nicht verändern, sondern nur beim Zeichnen überspringen
        drawWaveform(samples, ctx, canvas.width, canvas.height, 0, true); // true bedeutet, das erste Sample wird nicht gezeichnet

        canvas.addEventListener("click", function (e) {
          stopAllAudio();
          clickCanvas = true;
          var rect = canvas.getBoundingClientRect();
          var clickX = e.clientX - rect.left;
          clickProgress = clickX / rect.width;
          audio.currentTime = clickProgress * audio.duration;

          var icon = playButton.querySelector("i");
          if (icon.classList.contains("fa-play")) {
            icon.classList.remove("fa-play");
            icon.classList.add("fa-pause");
          }
          audio.play();
          audio.classList.add("playing-audio");
        });

        audio.addEventListener("loadedmetadata", () => {
          if (clickCanvas) {
            audio.currentTime = clickProgress * audio.duration;
          }
        });

        audio.addEventListener("timeupdate", function () {
          var progress = audio.currentTime / audio.duration;
          drawWaveform(samples, ctx, canvas.width, canvas.height, progress, true);
        });

        audio.addEventListener("ended", function () {
          var icon = playButton.querySelector("i");
          if (icon.classList.contains("fa-pause")) {
            icon.classList.remove("fa-pause");
            icon.classList.add("fa-play");
          }
          audio.classList.remove("playing-audio");
          drawWaveform(samples, ctx, canvas.width, canvas.height, 0, true);
        });
      })
      .catch((error) => console.error("Error fetching JSON data:", error));
  }

  /**
   * Zeichnet die Wellenform auf das Canvas.
   * @param {Array<number>} samples - Die Audiodaten.
   * @param {CanvasRenderingContext2D} ctx - Der Canvas-Zeichenkontext.
   * @param {number} width - Die Breite des Canvas.
   * @param {number} height - Die Höhe des Canvas.
   * @param {number} progress - Der Fortschritt der Wiedergabe (zwischen 0 und 1).
   * @param {boolean} skipFirstSample - Ob das erste Sample übersprungen werden soll.
   */
  function drawWaveform(samples, ctx, width, height, progress, skipFirstSample = false) {
    var maxAbsoluteValue = Math.max(...samples.map(Math.abs));
    var halfHeight = height / 2;
    var step = halfHeight / maxAbsoluteValue;
    var endIndex = Math.floor(samples.length * progress);

    ctx.clearRect(0, 0, width, height);

    // Start bei 1, wenn das erste Sample übersprungen werden soll
    var start = skipFirstSample ? 1 : 0;

    for (var i = start; i < samples.length; i++) {
      var normalizedSample = Math.abs(samples[i]) * step;
      var x = (i / samples.length) * width;
      var y1 = halfHeight - normalizedSample;
      var y2 = halfHeight + normalizedSample;

      ctx.strokeStyle = i <= endIndex ? "#eee" : "#555";
      ctx.lineWidth = 4;
      ctx.beginPath();
      ctx.moveTo(x, y1);
      ctx.lineTo(x, y2);
      ctx.stroke();
    }
  }

  /**
   * Stoppt alle aktuell spielenden Audio-Elemente und setzt deren Zustand zurück.
   */
  function stopAllAudio() {
    var allAudio = document.querySelectorAll("audio.playing-audio");
    allAudio.forEach((audio) => {
      audio.pause();
      audio.currentTime = 0;
      audio.classList.remove("playing-audio");

      // Finden des zugehörigen Play-Buttons anhand des Containers
      var container = audio.parentElement;
      var playButton = container.querySelector(".demo-btn-contain");
      if (playButton) {
        var icon = playButton.querySelector("i");
        if (icon && icon.classList.contains("fa-pause")) {
          icon.classList.remove("fa-pause");
          icon.classList.add("fa-play");
        }
      }
    });
  }
});

        } catch(err){}
;
try {
          document.addEventListener("DOMContentLoaded", function () {
  var audioSources = [
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/drum_loop_8_155bpm.mp3?v=1770728000",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/drum_loop_12_147bpm.mp3?v=1770728001",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/drum_loop_13_151bpm.mp3?v=1770728001",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/drum_loop_19_151bpm.mp3?v=1770728000"
  ];

  var jsonSources = [
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/drum_loop_8_155bpm.json?v=1770727999",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/drum_loop_12_147bpm.json?v=1770727999",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/drum_loop_13_151bpm.json?v=1770727999",
    "https://cdn.shopify.com/s/files/1/0666/5656/7561/files/drum_loop_19_151bpm.json?v=1770727999"
  ];

  const elements = document.querySelectorAll('#player-set-8888 [id*="waveform-container"]');

  elements.forEach((element) => {
    const indexMatch = element.id.match(/\d+/);
    if (!indexMatch) return; // Sicherstellen, dass eine Nummer gefunden wurde
    const index = parseInt(indexMatch[0], 10);
    const adjustedIndex = index - 9; // IDs beginnen bei 10
    const container = element;
    createWaveformPlayer(index, audioSources[adjustedIndex - 1], jsonSources[adjustedIndex - 1], container);
  });

  function createWaveformPlayer(index, audioSrc, jsonSrc, container) {
    var clickCanvas = false;
    var clickProgress = 0;

    var div = document.createElement("div");
    div.setAttribute("class", "waveform");

    var canvas = document.createElement("canvas");
    canvas.width = 850;
    canvas.height = 100;
    canvas.setAttribute("class", "waveform-canvas");

    var audio = document.createElement("audio");
    audio.src = audioSrc;
    audio.preload = "auto";

    var playButton = document.createElement("div");
    playButton.setAttribute("id", "btn-contain" + index);
    playButton.setAttribute("class", "demo-btn-contain demo-btn-play");
    playButton.innerHTML =
      '<i id="pbtn' +
      index +
      '" class="demo-btn fas fa-play fa-fw fa-inverse"></i>';

    playButton.addEventListener("click", function () {
      var icon = playButton.querySelector("i");
      if (icon.classList.contains("fa-play")) {
        stopAllAudio();
        icon.classList.remove("fa-play");
        icon.classList.add("fa-pause");
        audio.play();
        audio.classList.add("playing-audio");
      } else {
        icon.classList.remove("fa-pause");
        icon.classList.add("fa-play");
        audio.pause();
        audio.classList.remove("playing-audio");
      }
    });

    var waveform = document.createElement("div");
    waveform.setAttribute("id", "waveform" + index);
    waveform.setAttribute("class", "waveform-contain");

    waveform.appendChild(canvas);

    div.appendChild(playButton);
    div.appendChild(waveform);

    div.appendChild(audio);

    container.appendChild(div);

    fetch(jsonSrc)
      .then((response) => response.json())
      .then((data) => {
        var ctx = canvas.getContext("2d");
        var samples = data.samples;

        // Hier das erste Sample nicht verändern, sondern nur beim Zeichnen überspringen
        drawWaveform(samples, ctx, canvas.width, canvas.height, 0, true); // true bedeutet, das erste Sample wird nicht gezeichnet

        canvas.addEventListener("click", function (e) {
          stopAllAudio();
          clickCanvas = true;
          var rect = canvas.getBoundingClientRect();
          var clickX = e.clientX - rect.left;
          clickProgress = clickX / rect.width;
          audio.currentTime = clickProgress * audio.duration;

          var icon = playButton.querySelector("i");
          if (icon.classList.contains("fa-play")) {
            icon.classList.remove("fa-play");
            icon.classList.add("fa-pause");
          }
          audio.play();
          audio.classList.add("playing-audio");
        });

        audio.addEventListener("loadedmetadata", () => {
          if (clickCanvas) {
            audio.currentTime = clickProgress * audio.duration;
          }
        });

        audio.addEventListener("timeupdate", function () {
          var progress = audio.currentTime / audio.duration;
          drawWaveform(samples, ctx, canvas.width, canvas.height, progress, true);
        });

        audio.addEventListener("ended", function () {
          var icon = playButton.querySelector("i");
          if (icon.classList.contains("fa-pause")) {
            icon.classList.remove("fa-pause");
            icon.classList.add("fa-play");
          }
          audio.classList.remove("playing-audio");
          drawWaveform(samples, ctx, canvas.width, canvas.height, 0, true);
        });
      })
      .catch((error) => console.error("Error fetching JSON data:", error));
  }

  /**
   * Zeichnet die Wellenform auf das Canvas.
   * @param {Array<number>} samples - Die Audiodaten.
   * @param {CanvasRenderingContext2D} ctx - Der Canvas-Zeichenkontext.
   * @param {number} width - Die Breite des Canvas.
   * @param {number} height - Die Höhe des Canvas.
   * @param {number} progress - Der Fortschritt der Wiedergabe (zwischen 0 und 1).
   * @param {boolean} skipFirstSample - Ob das erste Sample übersprungen werden soll.
   */
  function drawWaveform(samples, ctx, width, height, progress, skipFirstSample = false) {
    var maxAbsoluteValue = Math.max(...samples.map(Math.abs));
    var halfHeight = height / 2;
    var step = halfHeight / maxAbsoluteValue;
    var endIndex = Math.floor(samples.length * progress);

    ctx.clearRect(0, 0, width, height);

    // Start bei 1, wenn das erste Sample übersprungen werden soll
    var start = skipFirstSample ? 1 : 0;

    for (var i = start; i < samples.length; i++) {
      var normalizedSample = Math.abs(samples[i]) * step;
      var x = (i / samples.length) * width;
      var y1 = halfHeight - normalizedSample;
      var y2 = halfHeight + normalizedSample;

      ctx.strokeStyle = i <= endIndex ? "#eee" : "#555";
      ctx.lineWidth = 4;
      ctx.beginPath();
      ctx.moveTo(x, y1);
      ctx.lineTo(x, y2);
      ctx.stroke();
    }
  }

  /**
   * Stoppt alle aktuell spielenden Audio-Elemente und setzt deren Zustand zurück.
   */
  function stopAllAudio() {
    var allAudio = document.querySelectorAll("audio.playing-audio");
    allAudio.forEach((audio) => {
      audio.pause();
      audio.currentTime = 0;
      audio.classList.remove("playing-audio");

      // Finden des zugehörigen Play-Buttons anhand des Containers
      var container = audio.parentElement;
      var playButton = container.querySelector(".demo-btn-contain");
      if (playButton) {
        var icon = playButton.querySelector("i");
        if (icon && icon.classList.contains("fa-pause")) {
          icon.classList.remove("fa-pause");
          icon.classList.add("fa-play");
        }
      }
    });
  }
});

        } catch(err){}
